import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputProps,
  InputRightAddon,
} from '@wegroup/design-system';

interface Props {
  error?: string;
  symbol?: string | null;
  isDisabled?: boolean;
  prefilled?: boolean;
}

const TextInput: React.FC<React.PropsWithChildren<InputProps & Props>> = ({
  prefilled,
  error,
  symbol,
  isDisabled,
  ...props
}) => {
  return (
    <FormControl isInvalid={!!error}>
      <InputGroup variant={prefilled ? 'flowsPrefilled' : 'flows'}>
        <Input {...props} isDisabled={isDisabled} />
        {symbol && <InputRightAddon>{symbol}</InputRightAddon>}
      </InputGroup>
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default TextInput;
